import React from 'react';

const NoDetails = () => (
  <div className="col-md-18">
    <span>There are no additional settings defined for this product.</span>
  </div>
);

export default NoDetails;
